import React from "react";
import List from "../components/List";
import hipladeTemplate from "../../common/template";

function ListGenhi() {
  return <List />;
}

export default hipladeTemplate(ListGenhi);
